"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var doshx_controls_web_1 = require("doshx_controls_web");
var connected_channels_box_1 = __importDefault(require("./connected_channels_box"));
var shopify_svg_1 = __importDefault(require("../../../../../../assets/logos/shopify.svg"));
var ConnectedChannelsComponent = function (props) {
    var _a;
    var values = props.values, updateValues = props.updateValues;
    var channels = values.channels;
    var _b = react_1.default.useState(null), localChannels = _b[0], setLocalChannels = _b[1];
    (0, react_1.useEffect)(function () {
        if (localChannels || (channels && channels.length > 0)) {
            var _channels = channels.reduce(function (acc, curr) {
                var _a;
                var _b;
                ((_a = acc[_b = curr.channel]) !== null && _a !== void 0 ? _a : (acc[_b] = [])).push(curr);
                return acc;
            }, {});
            setLocalChannels(_channels);
        }
    }, [channels]);
    console.log("channels-pre", channels);
    console.log("localChannels-pre", localChannels);
    return ((0, jsx_runtime_1.jsx)(doshx_controls_web_1.BoxControl, __assign({ backgroundColor: "bg-white", variant: "filled", className: "" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex-1 flex-col gap-4" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "Connected Channels", bold: true, textColor: "text-black" }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-col lg:flex-row gap-4 justify-left" }, { children: (0, jsx_runtime_1.jsx)(connected_channels_box_1.default, { logo: shopify_svg_1.default, channel: "shopify", channels: (_a = localChannels === null || localChannels === void 0 ? void 0 : localChannels.SHOPIFY) !== null && _a !== void 0 ? _a : [], updateValues: updateValues }) }))] })) })));
};
exports.default = ConnectedChannelsComponent;
